<script>
    import HalfStar from './HalfStar.svelte';
    import FullStar from './FullStar.svelte';
    export let nightProducts = [];
    export let generateStars;
</script>

<div class="routine">
    <h2>Night</h2>
    {#each nightProducts as product, index (product)}
        {@const stars = generateStars(product.Rating)}
        <a href={product["SourceLink"]} target="_blank" class="product-link">
            <div class="item">
                <p>{index + 1}. {product["ProductType"]}: {product["BrandName"]} {product["ProductName"]}</p>
                <p>
                    {#if Number.isInteger(stars.fullStars) && stars.fullStars >= 0}
                    {#each Array(stars.fullStars) as _, i}
                        <FullStar class="star" />
                    {/each}
                {/if}
                {#if stars.halfStar}
                    <HalfStar class="star" />
                {/if}
                {stars.emptyStars}
                {Number(product.Rating).toFixed(2)}
                ({product.Reviews} Reviews)
                </p>
            </div>
        </a>
    {/each}
</div>

<style>
    /* No panel here: the routine screen already wraps this in a card, and two
       nested bordered surfaces read as a box inside a box. */
    .routine {
        font-family: var(--font-body);
    }

    h2 {
        margin: 0 0 var(--space-6);
        padding-bottom: var(--space-4);
        border-bottom: 1px solid var(--border-strong);
        font-family: var(--font-display);
        font-size: var(--text-xl);
        font-weight: var(--weight-regular);
        letter-spacing: var(--track-none);
        text-transform: none;
        color: var(--cream);
    }

    .product-link {
        display: block;
        color: inherit;
        text-decoration: none;
    }

    /* Hover tints the row instead of shifting it sideways, so the list does
       not jitter as the pointer crosses it. */
    .item {
        padding: var(--space-4) var(--space-3);
        margin-inline: calc(-1 * var(--space-3));
        border-bottom: 1px solid var(--border);
        transition: background var(--transition);
    }

    .product-link:hover .item {
        background: var(--hover-veil);
    }

    .product-link:last-child .item {
        border-bottom: none;
    }

    .item p {
        margin: 0;
        font-size: var(--text-sm);
        line-height: var(--leading-normal);
        letter-spacing: var(--track-none);
        text-transform: none;
        color: var(--cream);
    }

    .item p + p {
        margin-top: var(--space-2);
        font-size: var(--text-xs);
        color: var(--text-muted);
    }
</style>
